export const getCookie = (name) => {
  const match = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`));

  return match ? decodeURIComponent(match.split('=')[1]) : null;
};

// SameSite=None + Partitioned so the cookie survives inside the embedded
// checkout iframe on merchant sites, where browsers partition third-party
// storage.
export const setCookie = (name, value, maxAgeDays) => {
  const maxAge = maxAgeDays * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; max-age=${maxAge}; path=/; SameSite=None; Secure; Partitioned`;
};
